<p-dialog header="Representative Order Viewer" id="representative-order-viewer"
  width="constantService.getResolutionWidth()" [style]="{width: '100%', minWidth: '70%', height:'90%', minHeight:'50%', overflow:'scroll' }" [modal]="false" height="auto" 
  [maximizable]="true" [(visible)]="isRepresentativeOrderDisplay" [modal]="true" maximizable="true"
  (onHide)="closeDialogbox()">

  <div class="Container">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <!-- Representative Order Code   -->
      <mat-expansion-panel [expanded]="selectedRow.length > 0 || panelOpenState" (opened)="panelOpenState = true"
        (closed)="panelOpenState = true">
        <mat-expansion-panel-header [style]="{'margin':'2px 0px !important'}">
          <span class="ui-grid-col-2 panel-title"
          [style]="{minWidth: '12%'}">Representative Order</span>
          <div class="ui-grid-col-12">
            <div id="representative-order-viewer-filter-panel">
              <div class="col-lg-12 ">
                <mat-chip-listbox aria-label="filter">
                  <span>
                    <mat-chip id="representative-order-viewer-date">
                      Report Date: {{reportDate}}
                    </mat-chip>
                    <mat-chip id="representative-order-viewer-orderID">
                      Order ID: {{orderID}}
                    </mat-chip>
                    <mat-chip id="representative-order-viewer-orderDate">
                      Order Date: {{orderDate | date: 'yyyy-MM-dd' }}
                    </mat-chip>
                    <mat-chip id="representative-order-viewer-symbol">
                      Symbol: {{symbol}}
                    </mat-chip>
                    <mat-chip id="representative-order-viewer-quantity">
                      Quantity : {{quantity==""?0:quantity}}
                    </mat-chip>
                    <mat-chip id="representative-order-viewer-orderID">
                      Price: {{orderType=='MKT'?orderType:price}}
                    </mat-chip>
                    <mat-chip id="representative-order-viewer-side">
                      Side: {{side}}
                    </mat-chip>
                    <mat-chip id="representative-order-viewer-eventType" [matTooltip]="getRepresentativeIndDetails(representativeInd)" 
                    [matTooltipShowDelay]="1000" matTooltipPosition="after">
                      Representative Indicator: {{representativeInd}}
                    </mat-chip>
                  </span>
                </mat-chip-listbox>
              </div>
            </div>
          </div>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- CAT ROEs Code   -->
    <mat-accordion>
      <mat-expansion-panel [expanded]="selectedRow.length > 0 || panelOpenState" (opened)="panelOpenState = true"
        (closed)="panelOpenState = true">
        <mat-expansion-panel-header>
          <span class="ui-grid-col-1 panel-title">CAT ROEs</span>
        </mat-expansion-panel-header>
        <mat-panel-description>
          <div class="ui-grid-col-12  nopadding table-container">
            <app-event-tree [SelectedRow]="selectedRow" [showFilter]=false [rows]="3">
            </app-event-tree>
          </div>
        </mat-panel-description>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- Aggregated Orders  Code   -->
    <mat-expansion-panel [expanded]="AggregatedOrdersData.length > 0 || panelOpenState" (opened)="panelOpenState = true"
      (closed)="panelOpenState = true">
      <mat-expansion-panel-header>
        <span class="ui-grid-col-2 panel-title">Aggregated Orders</span>

        <div class="ui-grid-col-12">
          <div class="col-lg-12 ">
            <mat-chip-listbox aria-label="filter">
              <span>
                <mat-chip id="representative-aggregated-orders-panel-quantity">
                  Sum Of Quantity :{{AggregatedOrdersSummary.sumOfQuantity}}
                </mat-chip>
              </span>
            </mat-chip-listbox>
          </div>
        </div>
      </mat-expansion-panel-header>
      <mat-panel-description>
        <div class="ui-grid-col-12  nopadding table-container">
          <app-turbo-table [GridColumns]="AggoGridColumns" [Dataset]="AggregatedOrdersData"
            [TotalRecords]=AggregatedOrdersData.length>
          </app-turbo-table>
        </div>
      </mat-panel-description>
    </mat-expansion-panel>

    <!-- Aggregated Orders Execution Code   -->
    <mat-expansion-panel [expanded]="AggregatedOrdersExecutionData.length > 0 || panelOpenState"
      (opened)="panelOpenState = true" (closed)="panelOpenState = true">
      <mat-expansion-panel-header>
        <span class="ui-grid-col-3 panel-title">Aggregated Order Executions </span>

        <div class="ui-grid-col-12">
          <div class="col-lg-12 ">
            <mat-chip-listbox aria-label="filter">
              <span>
                <mat-chip id="representative-aggregated-orders-execution-panel-quantity">
                  Sum Of Quantity :{{AggregatedOrdersExecutionSummary.sumOfQuantity}}
                </mat-chip>
                <mat-chip id="representative-aggregated-orders-panel-execution-minprice">
                  Min Price: {{AggregatedOrdersExecutionSummary.minPrice}}
                </mat-chip>
                <mat-chip id="representative-aggregated-orders-panel-execution-maxprice">
                  Max Price: {{AggregatedOrdersExecutionSummary.maxPrice}}
                </mat-chip>
              </span>
            </mat-chip-listbox>
          </div>
        </div>

      </mat-expansion-panel-header>
      <mat-panel-description>
        <div class="ui-grid-col-12  nopadding table-container">
          <app-turbo-table [GridColumns]="AggoExecutionGridColumns" [Dataset]="AggregatedOrdersExecutionData"
            [TotalRecords]=AggregatedOrdersExecutionData.length>
          </app-turbo-table>
        </div>
      </mat-panel-description>
    </mat-expansion-panel>

  </div>

    <ng-template #footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix float-right">
      <button type="button" id="representative-order-viewer-close" pButton icon="fa-close" style="background: #e54a23;"
        (click)="isRepresentativeOrderDisplay=false;" label="Close"></button>
    </div>
    </ng-template>
</p-dialog>